import React from 'react'
// eslint-disable-next-line no-unused-vars
import { TKelmanDraggableSimulation } from './KelmanDraggable-types'

const KelmanDraggableSimulation: React.FC<TKelmanDraggableSimulation> = ({
  simulationImage,
  simulationContainer,
  children
}) => {
  const Container: React.CSSProperties = {
    height: 650,
    width: 800,
    position: 'absolute'
  }

  return (
    <div>
      <div style={simulationContainer || Container}>
        <img
          src={simulationImage}
          alt='Simulation Image'
          style={{
            position: 'absolute',
            height: simulationContainer?.height || Container.height,
            width: simulationContainer?.width || Container.width
          }}
        />
        {children}
      </div>
    </div>
  )
}

export default KelmanDraggableSimulation
